import { render, staticRenderFns } from "./TableSection.vue?vue&type=template&id=3bbc6306&scoped=true"
import script from "./TableSection.vue?vue&type=script&lang=js"
export * from "./TableSection.vue?vue&type=script&lang=js"
import style0 from "./TableSection.vue?vue&type=style&index=0&id=3bbc6306&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc6306",
  null
  
)

export default component.exports